import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import ReactHtmlParser from "react-html-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "../../revvComponents";

// internal Imports
import { GlobalUtils } from "../../utils";
import PlanChangeRequest from "../../components/SettingsWrapper/BillingSettings/PlanChangeRequest";

import { IMAGE_URLS } from "../../constants";

// Action Imports
import { getSubscriptionCheckoutSessionID } from "../../actions/SettingsActions/settingsActions";
import { fetchPricingInfoAction } from "../../actions/CommonActions/commonActions";
import { buttonClickEvent, customGAEvent } from "../../gtm/gtmutils";
import GTM_EVENTS from "../../gtm/gtmevents";
import { GTM_CUSTOM_EVENTS, GTM_EVENT_PARAMS } from "../../gtm/gtmcustomevents";

// Destructuring
const { readDataFromLocalStorage, writeDataToLocalStorage } = GlobalUtils;
const { OFFER_ARROW } = IMAGE_URLS;

class SeeAllPlansPopup extends Component {
  state = {
    monthlyTabSelected: null,
    showContactUsPopUp: false,
  };

  componentDidMount() {
    this.props
      .fetchPricingInfoAction()
      .then(() => console.debug("pricing.yaml file fetched"))
      .catch(() => console.error("failed to fetch pricing.yaml file"));
  }

  _updatePlan = plan => {
    const isMonthlyTabSelected =
      this.state.monthlyTabSelected === null
        ? this.props.defaultPlanType === "monthly"
        : this.state.monthlyTabSelected;

    let {
      price: {
        monthly: { planAlias },
      },
    } = plan;
    if (!isMonthlyTabSelected) {
      ({ planAlias } = plan.price.annually);
    }
    const CURRENT_PLAN_HASH = readDataFromLocalStorage("planHash");
    writeDataToLocalStorage("oldPlanHash", CURRENT_PLAN_HASH);
    this.props.getSubscriptionCheckoutSessionID(planAlias);
  };

  _getPlanPricing = plan => {
    const { priceLabel, price } = plan;
    const isMonthlyTabSelected =
      this.state.monthlyTabSelected === null
        ? this.props.defaultPlanType === "monthly"
        : this.state.monthlyTabSelected;

    // free & enterprise plans
    if (priceLabel) {
      return (
        <span>
          <div className="seeallplans-name" style={{ color: plan.colorHex }}>
            {plan.planName}
          </div>
          <div className="seeallplans-pricing">
            <span className="seeallplans-monthlycharge-value">
              {priceLabel.name}
            </span>
          </div>
          <div className="seeallplans-yearlycharge">{priceLabel.charge}</div>
        </span>
      );
    }

    const selectedTabPrice = isMonthlyTabSelected
      ? price.monthly
      : price.annually;

    const monthly = selectedTabPrice.pricePerMonth;
    const cancelled = selectedTabPrice.priceCancelled;
    const annually = selectedTabPrice.pricePerYear;
    return (
      <span>
        <div className="seeallplans-name" style={{ color: plan.colorHex }}>
          {plan.planName}
        </div>
        <div className="seeallplans-pricing">
          <span className="seeallplans-monthlycharge-cancelledvalue">
            {cancelled}
          </span>
          <span className="seeallplans-monthlycharge-value">{monthly}</span>

          <span className="seeallplans-charge"> / user / month</span>
        </div>
        <div className="seeallplans-yearlycharge">
          {isMonthlyTabSelected ? "billed monthly" : annually}
        </div>
      </span>
    );
  };

  _handlePlanActionClick = plan => {
    if (plan.submitBtn.type === "billing") {
      const params = {};
      params[GTM_EVENT_PARAMS.PLAN_NAME] = plan.planName;
      params[GTM_EVENT_PARAMS.PLAN_TYPE] = "Subscription";
      params[GTM_EVENT_PARAMS.POPUP_NAME] = "See All Plans Popup";
      customGAEvent(GTM_CUSTOM_EVENTS.PAYMENT_START, params);

      buttonClickEvent(GTM_EVENTS.SEEALLPLANPOPUP_SUBSCRIBE_CLICK);
      this._updatePlan(plan);
    } else if (plan.submitBtn.type === "contact") {
      this.setState({ showContactUsPopUp: true });
    } else if (plan.submitBtn.type === "link" && plan.submitBtn.url) {
      const newWindow = window.open(
        plan.submitBtn.url,
        "_blank",
        "noopener,noreferrer",
      );
      if (newWindow) newWindow.opener = null;
    }
  };

  _onTabSelection = flag => {
    if (flag) {
      buttonClickEvent(GTM_EVENTS.SEEALLPLANPOPUP_MONTHLY_TAB_CLICK);
    } else {
      buttonClickEvent(GTM_EVENTS.SEEALLPLANPOPUP_ANNUAL_TAB_CLICK);
    }
    this.setState({ monthlyTabSelected: flag });
  };

  render() {
    const { planDetails } = this.props;
    if (planDetails) {
      const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

      const plansData = this.props.trialEnd
        ? planDetails.trialEnd
        : planDetails.upgrade;
      const isMonthlyTabSelected =
        this.state.monthlyTabSelected === null
          ? this.props.defaultPlanType === "monthly"
          : this.state.monthlyTabSelected;
      return (
        <Fragment>
          <Modal
            open
            center
            showCloseIcon={false}
            onClose={this.props.onClose}
            classNames={{
              modal: "seeallplans-modal-popup",
            }}
            closeOnOverlayClick={false}>
            <div className="seeallplans-container">
              <div className="seeallplans-close">
                <FontAwesomeIcon
                  icon={["far", "times"]}
                  onClick={this.props.onClose}
                  data-test="seeallplans-close"
                />
              </div>
              <div className="seeallplans-title"> {plansData.title}</div>
              <div className="seeallplans-row seeallplans-subheading-row">
                <div className="seeallplans-subheading">
                  {plansData.subTitle}
                </div>
                <div className="seeallplans-tabs">
                  <div className="seeallplans-tab-offer">
                    Save upto 20% on Annual plans
                  </div>
                  <img
                    src={OFFER_ARROW}
                    className="seeallplans-offericon"
                    alt="seeallplans-offericon"
                  />
                  <div
                    data-test="seeallplans-tab-annual"
                    className={`seeallplans-tab ${
                      !isMonthlyTabSelected ? "seeallplans-active-tab" : ""
                    }`}
                    role="button"
                    tabIndex={0}
                    onKeyPress={() => this._onTabSelection(false)}
                    onClick={() => this._onTabSelection(false)}>
                    Annually
                  </div>
                  <div
                    data-test="seeallplans-tab-monthly"
                    role="button"
                    className={`seeallplans-tab ${
                      isMonthlyTabSelected ? "seeallplans-active-tab" : ""
                    }`}
                    tabIndex={0}
                    onKeyPress={() => this._onTabSelection(true)}
                    onClick={() => this._onTabSelection(true)}>
                    Monthly
                  </div>
                </div>
              </div>
              <div className="seeallplans-plans-container">
                {plansData.plans &&
                  plansData.plans.map(plan => {
                    if (plan.isActive) {
                      return (
                        <section
                          className={`seeallplans-plan-section ${
                            plan.isPopular ? "most-popular" : ""
                          }`}>
                          {plan.isPopular && (
                            <div className="seeallplans-most-popular">
                              <span className="seeallplans-most-popular-text">
                                Most Popular
                              </span>
                            </div>
                          )}
                          {this._getPlanPricing(plan)}
                          <div className="seeallplans-catch-phrase">
                            {plan.catchPhrase}
                          </div>
                          {/* <hr className="seeallplans-dvider" /> */}
                          <div>
                            {CURRENT_USER &&
                            CURRENT_USER.roles &&
                            CURRENT_USER.roles.length > 0 &&
                            CURRENT_USER.roles[0].name === "User" ? (
                              <Button
                                type="four"
                                data-test="seeallplans-subscribe"
                                className="seeallplans-subscribe seeallplans-disabled ">
                                <Tooltip
                                  placement="top"
                                  overlay="Please contact your company's Revv admin to upgrade">
                                  <span>Contact to your Admin</span>
                                </Tooltip>
                              </Button>
                            ) : (
                              <Button
                                type="four"
                                data-test="seeallplans-subscribe"
                                className={`seeallplans-subscribe ${
                                  plan.submitBtn.type === "disabled"
                                    ? "seeallplans-disabled"
                                    : ""
                                } ${
                                  plan.submitBtn.type === "contact"
                                    ? "revv-btn-secondary"
                                    : ""
                                }`}
                                onClick={() => {
                                  this._handlePlanActionClick(plan);
                                }}>
                                {plan.submitBtn.label}
                              </Button>
                            )}
                          </div>
                          <div className="seeallplans-feature-wrapper">
                            {plan.planOffers &&
                              plan.planOffers.map(featureDetails => (
                                <div className="seeallplans-feature-list">
                                  <i>
                                    {" "}
                                    <FontAwesomeIcon icon={["far", "check"]} />
                                  </i>{" "}
                                  {ReactHtmlParser(featureDetails)}
                                </div>
                              ))}
                          </div>
                        </section>
                      );
                    }
                    return null;
                  })}
              </div>
              <div className="seeallplans-contact">
                Interested to know more about how Revv can help automate your
                document process?{" "}
                <span
                  data-test="seeallplans-contact-us"
                  role="button"
                  tabIndex={0}
                  onKeyPress={() => {}}
                  onClick={() => this.setState({ showContactUsPopUp: true })}>
                  Contact us
                </span>
              </div>
            </div>
          </Modal>
          {this.state.showContactUsPopUp && (
            <PlanChangeRequest
              currentPlan={this.props.currentPlan}
              onClose={() => this.setState({ showContactUsPopUp: false })}
            />
          )}
        </Fragment>
      );
    }
    return null;
  }
}

const mapStateToProps = state => {
  const {
    pricingInfo: { planDetails },
  } = state.CommonStore;
  const PLAN_STATUS = readDataFromLocalStorage("revv_planStatus");
  const trialEnd = PLAN_STATUS === "cancelled";

  const userSignUpInfo = readDataFromLocalStorage("userSignUpInfo");
  const currentPlan = userSignUpInfo && userSignUpInfo.billing_plan;

  return {
    currentPlan,
    defaultPlanType: planDetails && planDetails.defaultPlanType,
    planDetails,
    trialEnd,
  };
};

const mapDispatchToProps = {
  getSubscriptionCheckoutSessionID,
  fetchPricingInfoAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SeeAllPlansPopup);
